import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  MotifButton,
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifInput,
  MotifFormField,
  MotifErrorMessage,
} from '@ey-xd/motif-react';
import { Field, reduxForm } from 'redux-form';
import * as formHelpers from '../../scripts/formHelpers';

const DeleteTRSConfirmationModal = ({
  showDeleteTRSConfirmationModal,
  toggleShowDeleteTRSConfirmationModal,
  handleConfirm,
  apiErrorMessage,
  handleDismissErrorMessage,
}) => {
  const [confirmationInputText, setConfirmationInputText] = useState('');
  const [saveEnabled, setSaveEnabled] = useState(false);

  useEffect(() => {
    if (showDeleteTRSConfirmationModal) {
      setConfirmationInputText('');
      setSaveEnabled(false);
    }
  }, [showDeleteTRSConfirmationModal]);

  const handleConfirmationInput = (e) => {
    setConfirmationInputText(e.target.value);
    if (/^Delete$/gi.test(e.target.value)) {
      setSaveEnabled(true);
    } else {
      setSaveEnabled(false);
    }
  };
  const showHideConfirmationModal = () => {
    setConfirmationInputText('');
    toggleShowDeleteTRSConfirmationModal();
  };

  const closeButtonProps = {
    title: 'Delete TRS',
    'aria-label': 'Delete TRS',
    'data-testid': 'close',
  };

  return (
    <MotifModal
      show={showDeleteTRSConfirmationModal}
      data-testid="divDeleteTRSModal"
      onClose={showHideConfirmationModal}
      variant="default"
      size="lg"
    >
      <MotifModalHeader
        closeButtonProps={closeButtonProps}
        data-testid="mdHdrdeleteTRS"
      >
        Delete TRS
      </MotifModalHeader>
      <MotifModalBody>
        {formHelpers.showSubmissionError(
          apiErrorMessage,
          handleDismissErrorMessage
        )}
        <MotifFormField>
          <div className="row">
            <div className="field col-md-12">
              <Field
                name="TRSName"
                component={formHelpers.renderField}
                type="text"
                label="TRS Name"
                dataTestId="txtTRSName"
                className="w-100"
                disabled={true}
              />
            </div>
          </div>
        </MotifFormField>
        <span className="margin-bottom-1">
          Type &apos;Delete&apos; in the box below to confirm you want to make
          this change.
        </span>
        <div className="row">
          <div className="field col-md-12">
            <MotifInput
              type="text"
              name="confirmationInput"
              id="confirmationInput"
              onChange={handleConfirmationInput}
              value={confirmationInputText}
              required={true}
              placeholder="Delete"
              data-testid="txtDelete"
            />
          </div>
        </div>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton
          variant="secondary"
          className="right mt-3"
          onClick={() => {
            setConfirmationInputText('');
            toggleShowDeleteTRSConfirmationModal();
          }}
          data-testid="btnCancel"
          type="button"
        >
          Cancel
        </MotifButton>
        <MotifButton
          variant="primary"
          className="right mt-3"
          data-testid="btnConfirm"
          onClick={handleConfirm}
          type="submit"
          disabled={!saveEnabled}
        >
          Confirm
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
};

DeleteTRSConfirmationModal.propTypes = {
  showDeleteTRSConfirmationModal: PropTypes.bool,
  toggleShowDeleteTRSConfirmationModal: PropTypes.func,
  modifiedMappingsArray: PropTypes.array,
  handleConfirm: PropTypes.func,
  theme: PropTypes.string,
  initialValues: PropTypes.shape({
    TRSID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    TRSName: PropTypes.string,
  }),
};
export default reduxForm({
  form: 'deleteTRSForm',
  enableReinitialize: true,
})(DeleteTRSConfirmationModal);
